module.exports = __webpack_public_path__ + "static/media/oxford.18734b66.jpg";